import { createRouter, createWebHistory } from "vue-router";
// import { computed } from "vue";
// import store from "@/store";

function guard(to, from, next) {
  try {
    // Vérifier si localStorage.currentUser existe et est non vide
    if (!localStorage.currentUser || localStorage.currentUser === "" || localStorage.currentUser === "undefined") {
      next({ name: "loginUtilisateur" });
      return;
    }

    const user = JSON.parse(localStorage.currentUser);
    
    // Vérifier si l'utilisateur a un id valide
    if (user && user.id) {
      next();
    } else {
      // Utilisateur non connecté, rediriger vers la page de login
      next({ name: "loginUtilisateur" });
    }
  } catch (error) {
    // En cas d'erreur de parsing, rediriger vers la page de login
    next({ name: "loginUtilisateur" });
  }
}

function superAdminGuard(to, from, next) {
  let user = {};
  try {
    user = JSON.parse(localStorage.currentUser || "{}");
  } catch (error) {
    user = {};
  }
  if (user && user.permissions && user.permissions.super_admin === 1) {
    next();
  } else {
    next({ name: "homeUtilisateur" });
  }
}

const routes = [
  {
    path: "/",
    name: "loginUtilisateur",
    component: () => import("@/views/Public/loginUtilisateur.vue"),
  },
  {
    path: "/gallery/:code",
    name: "gallery",
    component: () =>
      import("@/views/Gallery.vue"),
    props: (route) => ({
      code: route.params.code,
    }),
    meta: {
      hide: true,
      guestPage: true,
    },
  },
  {
    path: "/diaporama/:code",
    name: "diaporama",
    component: () =>
      import("@/views/Diaporama.vue"),
    props: (route) => ({
      code: route.params.code,
    }),
    meta: {
      hide: true,
      guestPage: true,
    },
  },
  {
    path: "/forgot-password/:espace",
    name: "forgot-password",
    component: () => import("@/views/Public/forgot-password.vue"),
    props: true,
  },
  {
    path: "/reset-password/:espace/:code",
    name: "reset-password",
    component: () => import("@/views/Public/reset-password.vue"),
    props: true,
  },
  {
    path: "/loginUtilisateur",
    name: "loginUtilisateur2",
    component: () => import("@/views/Public/loginUtilisateur.vue"),
  },
  {
    path: "/app",
    name: "Layout",
    redirect: "/",
    component: () => import("@/Layout/index.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "homeUtilisateur",
        name: "homeUtilisateur",
        component: () =>
          import("@/views/Utilisateur/Accueil/HomeUtilisateur.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "evenements",
        name: "evenements",
        component: () =>
          import("@/views/Utilisateur/Evenements/Evenements.vue"),
        props: (route) => ({
          dateStart: route.query.dateStart,
          dateEnd: route.query.dateEnd,
          tabNumber: route.query.tabNumber ? parseInt(route.query.tabNumber) : null,
        }),
        meta: {
          hide: true,
        },
      },
      {
        path: "evenement/:id_event/medias",
        name: "evenement-medias",
        component: () =>
          import("@/views/Utilisateur/Evenements/EvenementAdminMedias.vue"),
        props: (route) => ({
          id_event: parseInt(route.params.id_event),
          id_client: route.query.id_client
            ? parseInt(route.query.id_client)
            : 0,
        }),
        meta: {
          hide: true,
        },
      },
      {
        path: "clients",
        name: "clients",
        component: () =>
          import("@/views/Utilisateur/Clients/Clients.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "client/:id",
        name: "client",
        component: () =>
          import("@/views/Utilisateur/Clients/Client.vue"),
        props: true,
        meta: {
          hide: true,
        },
      },
      {
        path: "bornes",
        name: "bornes",
        component: () =>
          import("@/views/Utilisateur/Bornes/Bornes.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "personnalisation",
        name: "personnalisation",
        component: () =>
          import("@/views/Utilisateur/Personnalisation/Personnalisation.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "utilisateurs",
        name: "utilisateurs",
        component: () =>
          import("@/views/Utilisateur/Utilisateurs/Utilisateurs.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "utilisateur/:id",
        name: "utilisateur",
        component: () => import("@/views/Utilisateur/Utilisateurs/Utilisateur.vue"),
        props: true,
        meta: {
          hide: true,
        },
      },
      {
        path: "catalogue-frizbooth",
        name: "catalogue-frizbooth",
        component: () =>
          import("@/views/Utilisateur/Catalogue/CatalogueFrizbooth.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "studio",
        name: "studio",
        component: () =>
          import("@/views/Studio.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "design-lab",
        name: "design-lab",
        component: () => import("@/views/DesignLab/DesignLab.vue"),
        beforeEnter: superAdminGuard,
        meta: {
          hide: true,
        },
      },




















      
      // {
      //   path: "blank-page",
      //   name: "blank-page",
      //   component: () => import("@/views/blank-page.vue"),
      // },
      // {
      //   path: "notifications",
      //   name: "notifications",
      //   component: () => import("@/views/notifications.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "homeFormateur",
      //   name: "DashBoard Formateur",
      //   component: () => import("@/views/Formateur/Accueil/HomeFormateur.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "sessionEntree",
      //   name: "sessionEntree",
      //   component: () =>
      //     import("@/views/Formateur/Sessions/SessionsEntree.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "sessionSortie",
      //   name: "sessionSortie",
      //   component: () =>
      //     import("@/views/Formateur/Sessions/SessionsSortie.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "sessionsMine",
      //   name: "sessionsMine",
      //   component: () =>
      //     import("@/views/Utilisateur/Sessions/SessionsMine.vue"),
      //   props: (route) => ({
      //     dateStart: route.query.dateStart,
      //     dateEnd: route.query.dateEnd,
      //   }),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "stagiairesMine",
      //   name: "stagiairesMine",
      //   component: () =>
      //     import("@/views/Utilisateur/Stagiaires/StagiairesMine.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "formateursMine",
      //   name: "formateursMine",
      //   component: () =>
      //     import("@/views/Utilisateur/Formateurs/FormateursMine.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "interpretesMine",
      //   name: "interpretesMine",
      //   component: () =>
      //     import("@/views/Utilisateur/Interpretes/InterpretesMine.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "suiviActivite",
      //   name: "suiviActivite",
      //   component: () => import("@/views/Utilisateur/Suivis/SuiviActivite.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "centre",
      //   redirect: "/app/centre/1",
      // },
      // {
      //   path: "centre/:tabNumber",
      //   name: "centre",
      //   component: () => import("@/views/Utilisateur/Centre/Centre.vue"),
      //   props: true,
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "site/:id",
      //   name: "site",
      //   component: () => import("@/views/Utilisateur/Sites/Site.vue"),
      //   props: true,
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "groupes",
      //   name: "groupes",
      //   component: () => import("@/views/Utilisateur/Stagiaires/Groupes.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "marches",
      //   name: "marches",
      //   component: () => import("@/views/Utilisateur/Marches/Marches.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "marche/:id",
      //   name: "marche",
      //   component: () => import("@/views/Utilisateur/Marches/Marche.vue"),
      //   props: true,
      //   meta: {
      //     hide: true,
      //   },
      // },
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      // {
      //   path: "ecommerce",
      //   name: "ecommerce",
      //   component: () => import("@/views/home/ecommerce.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "banking",
      //   name: "banking",
      //   component: () => import("@/views/home/banking.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "crm",
      //   name: "crm",
      //   component: () => import("@/views/home/crm.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "project",
      //   name: "project",
      //   component: () => import("@/views/home/project.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },

      // // components
      // {
      //   path: "button",
      //   name: "button",
      //   component: () => import("@/views/components/button/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "alert",
      //   name: "alert",
      //   component: () => import("@/views/components/alert/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "card",
      //   name: "card",
      //   component: () => import("@/views/components/card/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "carousel",
      //   name: "carousel",
      //   component: () => import("@/views/components/carousel.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "dropdown",
      //   name: "dropdown",
      //   component: () => import("@/views/components/dropdown/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "modal",
      //   name: "dodal",
      //   component: () => import("@/views/components/modal/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "tab-accordion",
      //   name: "tab-accordion",
      //   component: () => import("@/views/components/tab-accordion/index.vue"),
      // },
      // {
      //   path: "badges",
      //   name: "badges",
      //   component: () => import("@/views/components/badges.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "tooltip-popover",
      //   name: "tooltip-popover",
      //   component: () => import("@/views/components/tooltip-popover.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "typography",
      //   name: "typography",
      //   component: () => import("@/views/components/typography.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "colors",
      //   name: "colors",
      //   component: () => import("@/views/components/colors.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "image",
      //   name: "image",
      //   component: () => import("@/views/components/image/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "video",
      //   name: "video",
      //   component: () => import("@/views/components/video.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "pagination",
      //   name: "pagination",
      //   component: () => import("@/views/components/pagination"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "progress-bar",
      //   name: "progress-bar",
      //   component: () => import("@/views/components/progress-bar/index.vue"),
      //   meta: {
      //     groupParent: "components",
      //   },
      // },
      // {
      //   path: "placeholder",
      //   name: "placeholder",
      //   component: () => import("@/views/components/placeholder.vue"),
      //   meta: {
      //     groupParent: "placeholder",
      //   },
      // },
      // // widgets
      // {
      //   path: "basic",
      //   name: "basic",
      //   component: () => import("@/views/widgets/basic.vue"),
      //   meta: {
      //     groupParent: "widgets",
      //   },
      // },
      // {
      //   path: "statistic",
      //   name: "statistic",
      //   component: () => import("@/views/widgets/statistic.vue"),
      //   meta: {
      //     groupParent: "widgets",
      //   },
      // },

      // forms
      // {
      //   path: "input",
      //   name: "input",
      //   component: () => import("@/views/forms/input"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "input-group",
      //   name: "input-group",
      //   component: () => import("@/views/forms/input-group"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "input-layout",
      //   name: "input-layout",
      //   component: () => import("@/views/forms/input-layout"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "form-validation",
      //   name: "form-validation",
      //   component: () => import("@/views/forms/form-validation"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "form-wizard",
      //   name: "form-wizard",
      //   component: () => import("@/views/forms/form-wizard"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "form-repeater",
      //   name: "form-repeater",
      //   component: () => import("@/views/forms/form-repeater"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "input-mask",
      //   name: "input-mask",
      //   component: () => import("@/views/forms/input-mask"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "file-input",
      //   name: "file-input",
      //   component: () => import("@/views/forms/file-input"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "checkbox",
      //   name: "checkbox",
      //   component: () => import("@/views/forms/checkbox.vue"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "radio-button",
      //   name: "radio-button",
      //   component: () => import("@/views/forms/radio-button.vue"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "textarea",
      //   name: "textarea",
      //   component: () => import("@/views/forms/textarea"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "switch",
      //   name: "switch",
      //   component: () => import("@/views/forms/switch"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "select",
      //   name: "select",
      //   component: () => import("@/views/forms/select"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // {
      //   path: "date-time-picker",
      //   name: "date-time-picker",
      //   component: () => import("@/views/forms/date-time-picker"),
      //   meta: {
      //     groupParent: "forms",
      //   },
      // },
      // // table view
      // {
      //   path: "table-basic",
      //   name: "table-basic",
      //   component: () => import("@/views/table/basic"),
      //   meta: {
      //     groupParent: "Table",
      //   },
      // },
      // {
      //   path: "table-advanced",
      //   name: "table-advanced",
      //   component: () => import("@/views/table/advanced"),
      //   meta: {
      //     groupParent: "Table",
      //   },
      // },
      // // chart
      // {
      //   path: "appex-chart",
      //   name: "appex-chart",
      //   component: () => import("@/views/chart/appex-chart"),
      //   meta: {
      //     groupParent: "charts",
      //   },
      // },
      // {
      //   path: "chartjs",
      //   name: "chartjs",
      //   component: () => import("@/views/chart/chartjs"),
      //   meta: {
      //     groupParent: "charts",
      //   },
      // },
      // // app
      // {
      //   path: "calender",
      //   name: "calender",
      //   component: () => import("@/views/app/calendar"),
      // },
      // {
      //   path: "todo",
      //   name: "todo",
      //   component: () => import("@/views/app/todo"),
      //   meta: {
      //     hide: true,
      //     appheight: true,
      //   },
      // },
      // {
      //   path: "kanban",
      //   name: "kanban",
      //   component: () => import("@/views/app/kanban"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "email",
      //   name: "email",
      //   component: () => import("@/views/app/email"),
      //   meta: {
      //     groupParent: "Project",
      //     hide: true,
      //     appheight: true,
      //   },
      // },
      // {
      //   path: "projects",
      //   name: "projects",
      //   component: () => import("@/views/app/projects"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "project-details",
      //   name: "project-details",
      //   component: () => import("@/views/app/projects/project-details.vue"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "chat",
      //   name: "chat",
      //   component: () => import("@/views/app/chat"),
      //   meta: {
      //     hide: true,
      //     appheight: true,
      //   },
      // },
      // // normal pages
      // {
      //   path: "invoice",
      //   name: "invoice",
      //   component: () => import("@/views/utility/invoice"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "invoice-preview",
      //   name: "invoice-preview",
      //   component: () => import("@/views/utility/invoice/invoice-preview"),
      //   meta: {
      //     hide: true,
      //   },
      // },
      // {
      //   path: "invoice-edit",
      //   name: "invoice-edit",
      //   component: () => import("@/views/utility/invoice/invoice-edit"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "invoice-add",
      //   name: "invoice-add",
      //   component: () => import("@/views/utility/invoice/invoice-add"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "Pricing",
      //   name: "pricing",
      //   component: () => import("@/views/utility/pricing"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "faq",
      //   name: "faq",
      //   component: () => import("@/views/utility/faq"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "blog",
      //   name: "blog",
      //   component: () => import("@/views/utility/blog"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "blog-details",
      //   name: "blog-details",
      //   component: () => import("@/views/utility/blog/blog-details"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "testimonial",
      //   name: "testimonial",
      //   component: () => import("@/views/utility/testimonial"),
      //   meta: {
      //     groupParent: "Utility",
      //   },
      // },
      // {
      //   path: "map",
      //   name: "map",
      //   component: () => import("@/views/map"),
      // },
      {
        path: "profile",
        name: "profile",
        component: () => import("@/views/profile.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "profile-setting",
        name: "profile-setting",
        component: () => import("@/views/profile-setting.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "settings",
        name: "settings",
        component: () => import("@/views/settings.vue"),
        meta: {
          hide: true,
        }
      },
      {
        path: "facturation",
        name: "facturation",
        component: () => import("@/views/Facturation.vue"),
        meta: {
          hide: true,
        }
      },
      {
        path: "downloads",
        name: "downloads",
        component: () => import("@/views/Downloads.vue"),
        meta: {
          hide: true,
        }
      },
      {
        path: "aide-support",
        name: "aide-support",
        component: () => import("@/views/aide-support.vue"),
        meta: {
          hide: true,
        }
      },
      {
        path: "tickets",
        name: "tickets",
        component: () => import("@/views/Tickets.vue"),
        meta: {
          hide: true,
        }
      },
      // {
      //   path: "icons",
      //   name: "icons",
      //   component: () => import("@/views/icons.vue"),
      // },
    ],
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "/coming-soon",
    name: "coming-soon",
    component: () => import("@/views/utility/comming-soon"),
  },
  {
    path: "/under-construction",
    name: "under-construction",
    component: () => import("@/views/utility/under-construction"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  const titleText = to.name;
  const words = titleText.split(" ");
  const wordslength = words.length;
  for (let i = 0; i < wordslength; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
  }

  document.title = "FB-ADMIN  - " + words;
  next();
});

// Design « site vitrine » (assets/scss/design-lab/_v3*.scss) : pages invitées exclues, elles ont leur propre style.
export function applyAppDesign(route) {
  document.documentElement.classList.toggle("ds-v3", !route.meta.guestPage);
}

router.afterEach((to) => {
  applyAppDesign(to);
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
